import { Box, Text } from '@chakra-ui/react'
import { CatalogoBasePage, type ColumnConfig, type FieldConfig } from '../../../components/CatalogoBasePage'
import { mineralTypesCatalogService } from '../../../api/services'
import type { MineralTypeItem } from '../../../api/models/maestros.models'
import { themeColors } from '../../../theme'

const ActiveBadge = ({ active }: { active: boolean }) => (
  <Box
    display="inline-block"
    px={2}
    py={0.5}
    borderRadius="md"
    fontSize="10px"
    fontWeight="700"
    textTransform="uppercase"
    bg={active ? 'rgba(42, 138, 135, 0.2)' : 'rgba(200, 68, 47, 0.2)'}
    color={active ? '#2a8a87' : '#c8442f'}
  >
    {active ? 'Activo' : 'Inactivo'}
  </Box>
)

const columns: ColumnConfig<MineralTypeItem>[] = [
  { header: 'Código', render: (m) => <Text fontFamily="monospace" fontSize="sm" fontWeight="600" color={themeColors.text}>{m.code}</Text> },
  { header: 'Nombre', render: (m) => <Text fontSize="sm" color={themeColors.text}>{m.name}</Text> },
  { header: 'Descripción', render: (m) => <Text fontSize="sm" color={themeColors.textSecondary}>{m.description ?? '-'}</Text> },
  { header: 'Estado', render: (m) => <ActiveBadge active={m.isActive} /> },
]

const fields: FieldConfig<MineralTypeItem>[] = [
  { name: 'code', label: 'Código', type: 'text', required: true, placeholder: 'ej. AU' },
  { name: 'name', label: 'Nombre', type: 'text', required: true, placeholder: 'ej. Oro' },
  { name: 'description', label: 'Descripción', type: 'textarea', colSpan: 2 },
  { name: 'isActive', label: '¿Activo?', type: 'checkbox' },
]

export default function MineralTypesPage() {
  return (
    <CatalogoBasePage<MineralTypeItem>
      title="Tipos de Mineral"
      subtitle="Gestiona el catálogo de tipos de mineral"
      entityName="tipo de mineral"
      service={mineralTypesCatalogService as never}
      columns={columns}
      fields={fields}
      keyExtractor={(m) => m.id}
      idExtractor={(m) => m.id}
      searchPlaceholder="Buscar por código o nombre..."
      defaultValues={{ isActive: true }}
      createPermission="masters.write"
      updatePermission="masters.write"
      deletePermission="masters.write"
    />
  )
}
